import { DeleteOutlined, EditOutlined, SettingOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { PropsWithChildren, useCallback, useState } from "react";

export interface NodeContextMenuProps {
    onSettings?: () => void;
    onRename?: () => void;
    onDelete?: () => void;
    disabled?: boolean;
}

export const NodeContextMenu = ({
    children,
    onSettings,
    onRename,
    onDelete,
    disabled = false,
}: PropsWithChildren<NodeContextMenuProps>) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const [open, setOpen] = useState(false);

    const handleMenuClick: MenuProps["onClick"] = useCallback(
        ({ key }: { key: string }) => {
            setOpen(false);
            switch (key) {
                case "settings":
                    onSettings?.();
                    break;
                case "rename":
                    onRename?.();
                    break;
                case "delete":
                    onDelete?.();
                    break;
            }
        },
        [onSettings, onRename, onDelete]
    );

    const menuItems: MenuProps["items"] = [
        {
            key: "settings",
            icon: <SettingOutlined />,
            label: t("context_menu.settings"),
        },
        {
            key: "rename",
            icon: <EditOutlined />,
            label: t("context_menu.rename"),
        },
        {
            type: "divider",
        },
        {
            key: "delete",
            icon: <DeleteOutlined />,
            label: t("context_menu.delete"),
            danger: true,
        },
    ];

    if (disabled) {
        return <>{children}</>;
    }

    return (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={["contextMenu"]}
            open={open}
            onOpenChange={setOpen}
        >
            <span className="inline-block">{children}</span>
        </Dropdown>
    );
};
